const HotMass=[
    {
        id:1,
        title:"Лаваш з куркою і грибами 200/40г",
        price:"185 грн",
        src: require('../img/chiken.webp'),
        text:"лaваш, гомілка куряча, печериці, зелень, вершки, сир моцарела, часник, сирний соус",
      allergy: `🥛молоко (вершки, моцарела, сирний соус), 🌾глютен (лаваш), 🍄‍🟫гриби`
    },
    {
        id:2,
        title:"Лаваш з сиром, шинкою і томатами 200/40г",
        price:"170 грн",
        src:require('../img/tomato.webp'),
        text:"лаваш, сир гауда, помідор, шинка, часниковий соус",
              allergy: `🥛молоко (гауда), 🌾глютен (лаваш), 🥚яйце`
    },
    {
        id:3,
        title:"Лаваш з сиром і зеленню 200/40г",
        price:"170 грн",
        src:require('../img/chees.webp'),
        text:"лаваш, сир гауда, сир моцарела, зелень, соус тар-тар",
              allergy: `🥛молоко (гауда, моцарела, соус), 🌾глютен (лаваш)`
    },
    
]

export default HotMass;



























